<template>
  <div>
    <div id="myDIV" :class="{ 'disable-pull': mobile && Roomvisible }">
      <div class="client " :class="{ mobile, minimal: !Roomvisible }" v-show="ShowRoom">
        <conversation-client
          ref="client"
          source="https://chanchao.miraclemobile.com.tw/core"
          :visible="Roomvisible"
          :mobile="mobile"
          :token="token"
          :group-id="groupId"
          @load="onLoad"
          @error="onError"
          @close="onClose"
          @unread-count-changed="onUnreadCountChanged"
          @announcement-received="onAnnouncementReceived"
          @video-call-incoming="onVideoCallIncoming"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import isMobile from 'ismobilejs'
  import ConversationClient from 'conversation-client'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      ConversationClient,
    },
    data() {
      return {
        unread: 0,
        token: '',
        groupId: '76b2144d27db1266ea0dee86f5b01697',
        targetId: '',
        mobile: isMobile(window.navigator).any,
      }
    },

    watch: {
      Roomvisible(v) {
        if (v && this.mobile) {
          document.getElementById('myDIV').classList.add('disable-pull')
        } else {
          document.getElementById('myDIV').classList.remove('disable-pull')
        }
      },

      unread(newValue) {
        if (this.UnreadNum !== newValue) {
          this.$store.dispatch('getUnread', newValue)
        }
      },

      ChatEmail: function(newValue) {
        this.chat()
      },
    },

    methods: {
      onError(err) {
        console.log('onError', err)
      },
      onLoad() {
        console.log('onLoad')
      },

      chat() {
        this.$store.dispatch('Updatevisible', true)
        this.$store.dispatch('ShowChatRoom', true)

        this.$refs.client?.chat(this.ChatEmail)
        this.$store.dispatch('UpdateChatEmail', '')
      },
      onClose() {
        this.$store.dispatch('ShowChatRoom', false)
        this.$store.dispatch('Updatevisible', false)
      },
      onUnreadCountChanged(count) {
        console.log('count', count)
        this.unread = count
      },

      onVideoCallIncoming() {
        console.log('onVideoCallIncoming')

        this.$store.dispatch('ShowChatRoom', true)
        this.$store.dispatch('Updatevisible', true)
      },

      onAnnouncementReceived() {
        console.log('onAnnouncementReceived')
        this.openAnnouncement()
      },

      openAnnouncement() {
        if (this.ShowRoom) {
          if (!this.Roomvisible) {
            this.$refs.client?.openAnnouncement()
            this.$store.dispatch('Updatevisible', true)
          }
        } else {
          this.$refs.client?.openAnnouncement()
          this.$store.dispatch('Updatevisible', true)
          this.$store.dispatch('ShowChatRoom', true)
        }
      },
    },

    computed: {
      ...mapGetters(['ListStatus', 'UnreadNum', 'Roomvisible', 'ChatEmail', 'ShowRoom', 'exhcode']),
    },

    created() {
      const vm = this
      vm.token = vm.$cookies.get('as')

      vm.$bus.$on('callClose', function() {
        vm.onClose()
      })
    },
  }
</script>

<style scoped>
  #myDIV {
    overflow-y: auto;
  }

  .client {
    width: 900px;
    height: 590px;
  }

  .mobile {
    right: 0;
    width: 100%;
    height: 100%;
  }

  .minimal {
    width: 0;
    height: 0;
  }
</style>

<style>
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  body,
  html {
    display: flex;
    flex-direction: column;
  }

  #myDIV {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  body {
    z-index: 1;
  }

  #myDIV {
    z-index: 4002;
  }

  .disable-pull {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: hidden;
  }
</style>
